import { useQuery } from '@tanstack/react-query';
import adminLogService from '../api/adminLogService';

const KEYS = {
    all: ['adminLogs']
};

export const useAdminLogs = (params = {}) => {
    return useQuery({
        queryKey: [...KEYS.all, params],
        queryFn: () => adminLogService.getAll(params).then((res) => res.data),
        staleTime: 60 * 1000 // Logs can be slightly cached
    });
};
